class ActorUtils {
    static getActorDisplayName(userName, authSystem) {
        return authSystem === "ESCB" ? `${userName} [NCB]` : userName;
    }
}

export default ActorUtils;